﻿import { DataCategoryDataTypes } from "../ProcessingActivity.types.ts";

export interface SystemDetailData {
    id: string;
    name: string | null;
    distributionArea: DistributionArea;
    responsibleName: string | null;
    securityMeasureNames: Array<string>;
    dataProcessors: Array<string>;
    generateSharings: boolean;
    subProcessors: Array<SystemSubProcessorViewModel>;
}

export interface SystemSubProcessorViewModel {
    id: string;
    legalEntityId: string | null;
    transferBasisId: string | null;
    hasDataProcessorAgreement: boolean;
    transferImpactAssessmentId: string | null;
    hasTransferImpactAssessment: boolean;
    isLink: boolean;
    link: string | null;
    note: string | null;
}

export enum DistributionArea {
    GlobalSystem,
    LocalSystem,
    PhysicalArchive,
}

export interface ProcessingActivitySystemUpdateModel {
    systemId: string;
    dataCategories: Array<DataCategoryDataTypes>;
    groupEntities: Array<string>;
    processingActivitySystemSubProcessorUpdateModel: Array<ProcessingActivitySystemSubProcessorUpdateModel>;
    generateSharings: boolean;
}

export interface ProcessingActivitySystemSubProcessorUpdateModel {
    systemSubDataProcessorId: string;
    dataCategories: Array<DataCategoryDataTypes>;
}
